/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import * as ApiService from 'common/services/ApiService';

export function createSearchService(resourceName: string) {
    const baseUrl = `${resourceName}Searches`;

    return {
        find: (data: any) => ApiService.post(true, `${baseUrl}/search`, data),
        count: (data: any) =>
            ApiService.post(true, `${baseUrl}/search/count`, data),
    };
}

export const OrderSearchService = createSearchService('order');
export const QuoteSearchService = createSearchService('quote');
export const WorkOrderSearchService = createSearchService('workOrder');
export const SimplifiedDocumentSearchService =
    createSearchService('simplifiedDocument');
